module.exports = __webpack_public_path__ + "img/恐龙计时器.8dc4eefb.jpg";